<template>
  <div id="donasi" class="my-20 mx-4 bg-donasi1 grid py-4 md:grid-cols-2">
    <div>
      <p
        class="text-center text-cWhiteBase md:text-left md:mx-8 mt-8 xl:text-2xl xl:mt-16 xl:ml-20"
      >
        Salurkan donasi terbaik kalian melalui :
      </p>
      <hr
        class="mx-auto w-9/12 md:ml-8 md:w-9/12 lg:w-7/12 xl:w-8/12 border mt-1 border-cWhiteBase xl:ml-20"
      />
      <h4
        class="text-cWhiteBase mt-7 text-xl text-center md:text-left md:ml-8 md:text-3xl source xl:text-4xl xl:leading-normal xl:ml-20"
      >
        Hidup itu indah.
      </h4>
      <h4
        class="text-cWhiteBase text-xl text-center md:text-left md:ml-8 md:text-3xl source md:mr-8 xl:text-4xl xl:leading-normal xl:ml-20"
      >
        Seindah saat kamu bisa berbagi
      </h4>
    </div>
    <div class="bg-donasi2 mt-7 py-4 -ml-16 md:-ml-16">
      <p class="text-center text-cBlue font-bold">Rekening SeKuy Peduli</p>
      <hr
        class="mx-auto w-8/12 mb-4 mt-2 md:w-11/12 lg:w-8/12 xl:w-8/12 border mt-1 border-cLightBlue opacity-30"
      />

      <div class="grid grid-cols-2 ml-24 my-2 lg:mx-28 lg:mt-10">
        <p>Nama Bank</p>
        <div class="flex -ml-10">
          <p class="mr-3">:</p>
          <img src="../assets/bca.webp" alt="" />
        </div>
      </div>
      <div class="grid grid-cols-2 ml-24 my-2 lg:mx-28">
        <p>Kode Bank</p>
        <div class="flex -ml-10">
          <p class="mr-3">:</p>
          <p class="font-bold">014</p>
        </div>
      </div>
      <div class="grid grid-cols-2 ml-24 my-2 lg:mx-28">
        <p>No. Rek</p>
        <div class="flex -ml-10">
          <p class="mr-3">:</p>
          <p class="font-bold">8671888898</p>
        </div>
      </div>
      <div class="grid grid-cols-2 ml-24 my-2 lg:mx-28">
        <p>Atas Nama</p>
        <div class="flex -ml-10">
          <p class="mr-3">:</p>
          <p class="pb-4 font-bold">Dewi nurkhasanah or Rustandi</p>
        </div>
        <p class="text-transparent xl:mb-14">Dewi nurkhasanah or Rustandi</p>
      </div>
    </div>
    <img
      src="../assets/logo-transparent.webp"
      alt=""
      class="w-7/12 mx-14 absolute right-0 mt-48 md:w-4/12 md:mr-28 md:mt-20 md:pl-4 xl:w-3/12 xl:mr-44"
    />
  </div>
</template>

<script>
export default {
  name: "Donasi",
};
</script>

<style>
.bg-donasi1 {
  background-image: url("../assets/bg-donasi.webp");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.bg-donasi2 {
  background-image: url("../assets/bg-blue.svg");
  height: 100%;
  background-position: initial;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>